export function prizeImageLink(fileName) {
  return 'http://localhost:8001/uploads/prizesImages/' + fileName;
}